export enum AuthStatus {
    SUCCESS = 'authorize',
    ERROR = 'not-authorize',
  }